import { render } from "./senders.vue?vue&type=template&id=3394f10e"
import script from "./senders.vue?vue&type=script&lang=js"
export * from "./senders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__